import { Typography } from "@shared/ui.primitives";
import React from "react";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "variationName">;
};

export const HorizontalProductCardVariationName: React.FC<Props> = ({
  product
}) => {
  if (!product.variationName) return null;
  return (
    <Typography colour="secondary-dark" variant="product-sm">
      {product.variationName}
    </Typography>
  );
};
